import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
// import { UserInfoComponent } from '../../components/Profile/UserInfoComponent';
import { HeadTitle } from "../../components/share/HeadTitle";
import { Footer } from '../../components/share/Footer';
import { ProfileComponent } from "../../components/Profile/ProfileComponent";


export function UserInfoContainer() {
    const titleName = "ข้อมูลส่วนตัว";

    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ProfileComponent />
            <Footer />
        </div>
    );

} 